/**
 * Estados en los que el lead ya es (o fue) una póliza, no una cotización en
 * curso. Los comparten la tarjeta de cotizaciones y el Dashboard (que solo pinta
 * la póliza cuando la hay).
 */
const POLICY_STATUSES = new Set([
  "complete",
  "claim",
  "canceled",
  "rejected",
  "ops_review",
  "it_review",
  "insurer_review",
  "ready_to_send",
  "docs_pending",
  "csv_pending",
]);

export const isPolicyStatus = (status: string | null | undefined): boolean =>
  !!status && POLICY_STATUSES.has(status);
